import React, {useEffect, useRef, useState} from "react";
import CountUp from "react-countup";


export default function Counter({number,decimals,separator=" "}){

    const initialNumber=useRef(number)

    return <CountUp start={initialNumber.current} end={number} duration={2} separator={separator} decimals={decimals} onEnd={()=>{
        initialNumber.current=number
    }}/>
}